import { OPTIMIZELY_FEATURE_OFF, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
export const useSortBy = () => {
    const sortByVariation = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_NEW_USER);
    const isSortByFlagOff = sortByVariation === OPTIMIZELY_FEATURE_OFF;
    if (isSortByFlagOff) {
        // If the feature flag is off, we return the default sort by relevance.
        // This is to ensure that the sort by logic does not break when the feature flag is off.
        return 'relevance';
    }
    return sortByVariation;
};
